import { API_METHODS, API_URL } from "../constants/api.constants";
import { kf1AuthenticatedHttpClient} from "kfone-frontend-core";
import { AppEnvVariables } from "../constants/environment.constants";
const getConfig = async (payload: any = {}) => {
  const configUrl = `${AppEnvVariables.API_DOMAIN}${API_URL.CONFIG}?reportname=REWARD_BENCHMARK`;
  const shortLangCode = sessionStorage.getItem('kfone_short_lang_code');
  const payloadData = {
    countryCode: payload?.countryCode,
    orgCodes: payload?.orgCodes,
    language: payload?.language || shortLangCode || "en",
    year: payload?.year
  };
  const config: any = {
    method: API_METHODS.POST,
    url: configUrl,
    data: payloadData
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

const getCustomGradeSet = async (payload: any = {}) => {
  const customGradesetUrl =
    AppEnvVariables.API_DOMAIN +
    API_URL.CUSTOMER_GRADESET +
    `?countryCode=${payload.countryCode}&clientid=${payload.clientId}`;
  const config: any = {
    method: API_METHODS.GET,
    url: customGradesetUrl
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

const getPeerGroups = async (payload: any = {}) => {
  const peerGroupsUrl =
    AppEnvVariables.API_DOMAIN +
    API_URL.PEER_GROUPS +
    `?countryCode=${payload.countryCode}&clientid=${payload.clientId}&marketDefinitionKey=${payload.marketDefinitionKey}`;
  const config: any = {
    method: API_METHODS.GET,
    url: peerGroupsUrl
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

export { getConfig, getCustomGradeSet, getPeerGroups };
